import script from "./cta.vue?vue&type=script&lang=js"
export * from "./cta.vue?vue&type=script&lang=js"

import "./cta.vue?vue&type=style&index=0&id=78ac4ff3&lang=scss"

const __exports__ = script;

export default __exports__